module.exports = __webpack_public_path__ + "media/components/locations/page/images/card_default-7c0b22a5919c2beed105be8b7b9801bd.png";